import React from 'react';
import { useParams } from 'react-router-dom';
import CallCenter from '../../components/CallCenter';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Params = {
    resultCode: string;
    resultScore: string;
}

const PsychlngclCheckAngryResult: React.FC = () => {
    const {resultCode, resultScore} = useParams<Params>();
    const viewResult = (resultCode: string) => {
        switch(resultCode) {
            case "001" :
                return (
                    <>
                        <p className="result">화병증상 정상</p>
						<p>
							화병 관련 증상의 거의 나타나지 않고 있습니다. 편안한 마음으로 잘 적응하고 있는 것으로 보입니다. 
						</p>
                    </>
                )
            case "002" :
                return (
                    <>
                        <p className="result">화병증상 보통</p>
                        <p>
                            약간의 불편감은 있지만 보통 수준으로 적응문제나 생활속에서 큰 문제는 없을 것으로 보입니다. 
                        </p>
                    </>
                )
            case "003" :
                return (
                    <>
                        <p className="result">화병증상 높은 편</p>
                        <p>
                            화병 증상의 정도가 높은편입니다. 상당수의 우울증상이 함께 나타나고 있기 때문에 답답하고 무기력한 느낌을 자주 받을 수 있습니다. 이런 증상이 지속된다면 전문기관에 방문해 전문가의 상담을 받을 필요가 있습니다. 
                        </p>
                    </>
                )
            case "004" :
                return (
                    <>
                        <p className="result">화병증상 상당함</p>
                        <p>
                            상당수의 화병 증상이 나타나고 있습니다. 심리적 불편감은 물론 다수의 신체적 증상이 동반되고 있기 때문에 생활 속에서 큰 고통과 스트레스를 받고 있습니다. 가급적 빠른 시일 안에 전문기관에 방문하시어 검사와 치료를 받을 것을 권유드립니다. 
                        </p>
                    </>
                )
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='화병 자가진단'
                        />
                        <div className='mobileface testing'>
                            <div className="resultWrap angry">
                                <h3 className="f18 black">화병 자가진단</h3>
                                <h4 className="f14 green mt30">화병 자가진단 결과</h4>
                                <div className="total type2">
                                    <div className="grade">
                                        <p><span>{resultScore}</span>점</p>
                                    </div>
                                    <div className="text">
                                        {
                                            resultCode? (
                                                viewResult(resultCode)
                                            ) : (
                                                viewResult("001")
                                            )
                                        }
                                    </div>
								</div>
                                <CallCenter />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckAngryResult;